const tours = {
  tour: "관광", // translated 
  tours: "투어", // translated 
  addOn: "추가 기능", // translated 
  addOns: "추가 기능", // translated 
  availableEscapes: "이용 가능한 탈출", // translated 
  availableExperiences: "이용 가능한 체험", // translated 
  getRequest: "요청 받기", // translated 
  sendRequest: "요청 보내기", // translated 
};


export default tours;
